import React from 'react';

const TablePeraturan = ({ data }) => {

    return (
        <div className="overflow-x-auto m-2">
            <table className="table-auto min-w-full border rounded divide-y divide-gray-200 desktop:text-sm phone:text-xs">
                <thead className="bg-gray-50">
                    <tr>
                        <th
                            scope="col"
                            className="px-6 py-3 border text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            NO
                        </th>
                        <th
                            scope="col"
                            className="px-6 py-3 border text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            Nama File
                        </th>
                        <th
                            scope="col"
                            className="px-6 py-3 border text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            Tanggal
                        </th>
                        <th
                            scope="col"
                            className="px-6 py-3 border text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                            Aksi
                        </th>
                    </tr>
                </thead>
                {data.length > 0 ? (
                    <tbody className="bg-white divide-y divide-gray-200">
                        {data.map((row, rowIndex) => (
                            <tr key={rowIndex} className={ rowIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                                <td className="px-6 py-4 border">{rowIndex+1}</td>
                                <td className="px-6 py-4 border">{row.originalName}</td>
                                <td className="px-6 py-4 border">{row.createdAt.split("T")[0]}</td>
                                <td className="flex px-6 py-4">
                                    <a className='inline-flex hover:text-sky-500 hover:bg-blue-950 bg-gray-300 rounded' href={`/${row.path}`}
                                       download={`/${row.path}`}>
                                        <span className='px-2 py-2'>
                                            Download
                                        </span>
                                    </a>
                                    {/*<Link className='inline-flex hover:text-sky-500' target='_blank' rel="noopener noreferrer" to={`/${row.path}`}>*/}
                                    {/*    <span className='pt-2 pl-2 pr-2'>*/}
                                    {/*        <EyeIcon className='w-5 h-5' />*/}
                                    {/*    </span>*/}
                                    {/*</Link>*/}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                ) : (
                    <tbody className="bg-white divide-y divide-gray-200">
                    <tr>
                        <td className='text-center'>Data Kosong</td>
                    </tr>
                    </tbody>
                )}

            </table>
        </div>
    );
};

export default TablePeraturan;